import { c as _c } from "react/compiler-runtime";
import { AccountSettingsView } from "@repo/ui/components/profile/AccountSettingsView";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { authClient } from "@/clients/authClient";
import { jsx as _jsx } from "react/jsx-runtime";
export const Route = createFileRoute("/_app/mitt-konto/")({
  component: AccountPage
});
function AccountPage() {
  const $ = _c(15);
  const navigate = useNavigate();
  const {
    data: session
  } = authClient.useSession();
  if (!session) {
    return null;
  }
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== navigate) {
    t0 = () => {
      authClient.signOut();
      navigate({
        to: "/upptack"
      });
    };
    t1 = () => navigate({
      to: "/upptack"
    });
    t2 = () => navigate({
      to: "/mitt-konto/redigera-profil"
    });
    t3 = () => navigate({
      to: "/mitt-konto/andra-losenord"
    });
    t4 = () => navigate({
      to: "/mitt-konto/andra-epost"
    });
    t5 = () => navigate({
      to: "/mitt-konto/radera-konto"
    });
    $[0] = navigate;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t0 = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== session.user || $[8] !== t0 || $[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = /*#__PURE__*/_jsx(AccountSettingsView, {
      authClient: authClient,
      user: session.user,
      onSignOut: t0,
      onBack: t1,
      onEditProfile: t2,
      onChangePassword: t3,
      onChangeEmail: t4,
      onDeleteAccount: t5,
      statusMessage: null
    });
    $[7] = session.user;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}